
export const loginProvider = {
  google: 'google',
  facebook: 'facebook',
};
